import SpecialistCard from '@features/monitoringOffer/components/Card/SpecialistCard';
import { SelectingSpecialistModal } from '@features/monitoringOffer/components/SelectingSpecialistModal';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { usePageTitle } from '@hooks/usePageTitle';
import { useWindowSize } from '@hooks/useWindowSize';
import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Button, Skeleton } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMonitoringOffersStore } from 'services/monitoring-offers';
// import { Empty } from '../components/Empty';
import { useSnackbarStore } from '@components/shared/Snackbar/store';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { selectSpecialist } from 'services/monitoring-offers';
import SpecialistSuccess from '../components/SpecialistSuccess';

const styles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		boxShadow: 3,
		position: 'relative',
		bgcolor: 'white',
		borderRadius: 3,
	},
};

export const MonitoringSpecialistsPage = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();
	const { id } = useParams();
	const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
	const navigate = useNavigate();

	const size = useWindowSize();
	const [selectedSpecialist, setSelectedSpecialist] = useState<any>(null);
	const { specialists, specialistsLoading } = useMonitoringOffersStore();
	const [specialistSuccess, setSpecialSuccess] = useState(false);
	const [specialistRequestLoading, setSpecialistRequestLoading] = useState(false);
	const [specialistFullName, setSpecialistFullName] = useState<string | null>(null);

	usePageTitle(t('monitoring'));
	useAppbarTitle('monitoring');

	const handleOnClickSpecialist = (specialist: any) => {
		navigateWithLanguage(`/farmer/specialist-profile/${specialist?.user_id}?readonly=true`);
	};

	const handleSelectSpecialist = async () => {
		setSpecialistRequestLoading(true);
		setSpecialistFullName(selectedSpecialist?.first_name + ' ' + selectedSpecialist?.last_name);
		selectSpecialist(id, selectedSpecialist?.user_id)
			.then(() => {
				setSpecialSuccess(true);
				setSelectedSpecialist(null);
				setSpecialistRequestLoading(false);
			})
			.catch((error) => {
				showSnackbar('Error', t('somethingWentWrong'), 'error');
				console.error('The Promise is rejected!', error);
				setSpecialistRequestLoading(false);
			});
	};

	const isEmpty = !specialists || Object.keys(specialists).length === 0;

	useEffect(() => {
		if (isEmpty) {
			navigateWithLanguage('/farmer/monitoring/offers');
		}
	}, [isEmpty, navigateWithLanguage]);

	if (isEmpty) return null;

	return (
		<>
			{!specialistSuccess ? (
				<Box
					sx={{
						...styles.container,
						minHeight: size.width > 768 ? '100%' : 'auto',
					}}
				>
					<div className="flex justify-center items-center">
						<div className="absolute left-0 top-[50px]">
							<Button
								className="w-[120px]"
								type="submit"
								onClick={() => navigateWithLanguage('/farmer/monitoring/offers')}
								variant="text"
								sx={{ color: 'black' }}
								startIcon={<Icon path={mdiArrowLeft} size={1} />}
							>
								{t('back')}
							</Button>
						</div>
						<h2 className="md:text-2xl font-bold mb-6 mt-5">
							{t('requestsAndOffers.availableSpecialists')}
						</h2>
					</div>
					<div className="p-[20px]">
						{specialistsLoading ? (
							<div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4">
								{[...Array(6)].map((_, index) => (
									<Skeleton key={index} variant="rectangular" width="100%" height={137} />
								))}
							</div>
						) : (
							<div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4">
								{specialists.map((data: any, index: any) => (
									<SpecialistCard
										key={index}
										onClick={() => handleOnClickSpecialist(data)}
										specialist={data}
										onSelect={() => setSelectedSpecialist(data)}
									/>
								))}
							</div>
						)}
					</div>
					<SelectingSpecialistModal
						onSuccess={handleSelectSpecialist}
						specialist={selectedSpecialist}
						loading={specialistRequestLoading}
						open={selectedSpecialist}
						onClose={() => setSelectedSpecialist(null)}
					/>
				</Box>
			) : (
				<SpecialistSuccess specialistFullName={specialistFullName} />
			)}
		</>
	);
};
